import styled from "styled-components";

const Divider = styled.div`
    width: 100vw;
    height: 1px;
    background: #d2d2d2;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-top: 20px;
    margin-bottom: 20px;
`;

export default Divider;
